export default __webpack_public_path__ + "c39d2a6b855a41f73aa9f718962e6d29.png";